import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { userCollection } from "../../schema/user";
import PageLayout from "./layout";

export default function UserPage(): ReactNode {
  return (
    <PageLayout title="Users">
      <PaginatedList title="All Users" collection={userCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Account</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, name, email, accountName, accountId }) => (
              <tr key={id}>
                <td>{name}</td>
                <td>{email}</td>
                <td>
                  <Link to={`/admin/account/${accountId}`}>{accountName}</Link>
                </td>
                <td>
                  <Link to={`/admin/account/${accountId}/user/${id}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
